<template>
    <ContentOrLoading>
        <ShowSvgSectionsComponent
            v-if="svg"
            :secciones="secciones"
            :zona_id="zona_id"
            :svg="svg"
            @clickZona="clickRegion"
        />
    </ContentOrLoading>
</template>

<script>
    import ShowSvgSectionsComponent from '@/components/common/svg/secciones/ShowSvgSectionsComponent.vue';

    export default {
        props: {
            secciones: {
                type: Array,
                required: true
            }, 
            zona_id: {
                type: Number,
                required: false
            }
        },
        data() {
            return {
                svg : null,
            }            
        },
        created() {
            this.getSvgCode();
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            recinto() {
                return this.$store.getters.getRecinto;
            }
        },
        methods : {
            getSvgCode() {
                this.loading = true;

                const params = {
                    filters: {},
                    recinto_id: this.recinto.id,
                    lista_abonado_id: this.lista_abonados.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.temporada.recinto.secciones.svg'), params).then(res => {
                    this.svg = res.data.svg;
                });
            },
            clickRegion(zona) {
                this.$emit('clickZona', zona);          
            }        
        },
        components: {
            ShowSvgSectionsComponent
        }
    }
</script>